import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';

function LoginCheck({ cmp, baseUrl }) {

    const navigate = useNavigate();

    let Cmp = cmp;

    useEffect(() => {

        if (localStorage.getItem('access_token')) {
            navigate('/')
        }
    }, [])
    return (
        <>
            <>
                <Cmp baseUrl={baseUrl} />
            </>
        </>
    )
}

export default LoginCheck
